import { React } from '@gasbuddy/react';
import { Message } from 'semantic-ui-react';

export class DismissableMessage extends React.Component {
  state = { visible: true }

  handleDismiss = () => this.setState({ visible: false })

  render() {
    const { content, header, icon } = this.props;
    const { visible } = this.state;
    const props = {
      content,
      header,
      icon,
      onDismiss: this.handleDismiss,
    };

    return visible && (
      <Message {...props} />
    );
  }
}

DismissableMessage.propTypes = Message.propTypes;
